export default {
  homeBasic: {
    url: '/mall/home/base',
    type: 'post',
    parameter: {
      set: Array,
      pageCode: Number
    }
  },
  // 获取默认配置区域
  getSite: {
    url: '/mall/site/getSite',
    type: 'get'
  },
  // 设置配置区域
  setSite: {
    url: '/mall/site/setSite',
    type: 'get',
    parameter: {
      provinceCode: String,
      cityCode: String
    }
  },
  // 获取登录用户信息
  getLoginUser: {
    url: '/mall/userInfo/getLoginUser',
    type: 'get'
  }
}
